import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import useIntl from '/imports/core/api/useIntl';
import Container from '/imports/core/ui/atoms/Container';
import Flex from '/imports/core/ui/atoms/Flex';
import Link from '/imports/core/ui/atoms/Link';
import { getRoute, isBlogDomain } from '/lib/helpers';
import { useResponsive } from 'imports/core/api/responsiveContext';
import { Push } from '/components/Link';

const links = [
  { href: '/contact-us', title: 'Contact us', slug: 'header.contact_us' },
  { href: '/privacy-policy', title: 'Privacy', slug: 'footer.privacy_policy' },
  { href: '/terms-and-conditions', title: 'Terms of service', slug: 'footer.terms_conditions' },
];

const OnboardingFooter = () => {
  const router = useRouter();
  const { t, locale } = useIntl();
  const { host } = useResponsive();
  const [showCookiesSetting, setShowCookiesSetting] = useState(false);
  const [hide, setHide] = useState(true);

  const handleRedirection = (path) => () => Push(path, locale);

  useEffect(() => {
    setTimeout(() => {
      if (window?.axeptioSDK) {
        setShowCookiesSetting(true);
      }
    }, 3000);
  }, [locale]);

  useEffect(() => {
    setHide(router.pathname === '/onboard/start');
  }, [router?.pathname]);

  return (
    <FooterContainer hide={hide}>
      <FooterContent>
        <FooterLinks>
          {links.map(({ title, href, slug }, index) => (
            <FooterLink key={index} href={getRoute(href, locale, false, host, isBlogDomain(host))} target="_blank">
              {t(slug)}
            </FooterLink>
          ))}
          {showCookiesSetting && (
            <Flex $direction="row">
              <FooterLink $direction="row" onClick={handleRedirection('javascript:openAxeptioCookies()')}>
                {t('footer.cookies_settings')}
              </FooterLink>
            </Flex>
          )}
        </FooterLinks>
      </FooterContent>
    </FooterContainer>
  );
};

const FooterContainer = styled(Container).withConfig({
  shouldForwardProp: (prop) => !['hide'].includes(prop),
})`
  margin-top: auto;
  height: auto;
  min-height: 70px;
  padding: 24px;
  background-color: transparent;
  width: 100%;

  ${(p) => p.theme.max('xs')`
    height: 240px;
  `}

  ${(p) =>
    p.hide &&
    p.theme.max('sm')`
    display: none;
  `}
`;

const FooterContent = styled.div`
  position: relative;
`;

const FooterLinks = styled((p) => <Flex alignItems="center" justifyContent="center" {...p} />)`
  ${({ theme }) => theme.max('xs')`
    flex-flow: column nowrap;
  `};

  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      flex-direction: row-reverse;
    `}
`;

const FooterLink = styled((p) => <Link {...p} />)`
  margin: 0 16px;
  text-decoration: none;
  line-height: 24px;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  color: #1d1e1e;
  opacity: 0.5;
  cursor: pointer;
  ${({ theme }) => theme.max('md')`
    margin: 8px;
  `}
`;

export default OnboardingFooter;
